// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3mv8l","label":"Completed_label__1s8Cp"};